import { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CheckCircle2, KeyRound, Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/auth`;

export default function SetPasswordPage({ onLogin }) {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/set-password`, { token, password });
      onLogin(res.data.user, res.data.token);
      window.location.href = '/command-center';
    } catch (err) {
      setError(err.response?.data?.detail || 'That invite link is invalid or has expired.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#0b1120] text-white flex items-center justify-center p-6" data-testid="set-password-missing-token">
        <p className="text-white/60">This invite link is missing its token.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0b1120] text-white flex items-center justify-center p-6" data-testid="set-password-page">
      <Card className="max-w-sm w-full bg-[#111827] border-white/10 text-white">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-xl"><KeyRound className="h-5 w-5 text-amber-400" /> Set your password</CardTitle>
          <CardDescription className="text-white/60">Choose a password to activate your Personal AI Coach account.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-white/80">New password</Label>
              <Input type="password" required data-testid="set-password-input" value={password}
                     onChange={(e) => setPassword(e.target.value)} className="bg-white/5 border-white/15 text-white mt-1" />
            </div>
            <div>
              <Label className="text-white/80">Confirm password</Label>
              <Input type="password" required data-testid="set-password-confirm-input" value={confirm}
                     onChange={(e) => setConfirm(e.target.value)} className="bg-white/5 border-white/15 text-white mt-1" />
            </div>
            {error && <p className="text-sm text-red-400" data-testid="set-password-error">{error}</p>}
            <Button type="submit" disabled={submitting} data-testid="set-password-submit-btn"
                    className="w-full bg-amber-500 hover:bg-amber-400 text-black font-semibold h-11">
              {submitting ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Setting…</> : <><CheckCircle2 className="h-4 w-4 mr-2" /> Set password & sign in</>}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
